// react-app-polyfill must be the first line
import 'react-app-polyfill/ie11';
import React from 'react';
import { render } from 'react-dom';
import '../style/style.css';
import { BrowserRouter } from 'react-router-dom';
import { LoginConfigLoader } from './config-loader';

const PAGE_ID = 'login-app';
const element = document.createElement('div');
element.setAttribute('id', PAGE_ID);
document.body.appendChild(element);

render(<BrowserRouter basename={window.BASE_URL}><LoginConfigLoader /></BrowserRouter>, document.getElementById(PAGE_ID));
